import { Flex } from "@/atoms"
import { getApplicationSourceDisplay } from "@/helpers/application-source.helper"
import { useTranslation } from "@/hooks/useTranslation"
import { DeploymentUnitOutlined } from "@/icons"
import { ApplicationTag } from "@/molecules/ApplicationTag"
import { CopyLinkButton } from "@/molecules/CopyLinkButton"
import { TitleDrawer } from "@/molecules/TitleDrawer"
import { useApplicationEntity } from "@/organisms/Drawers/applications/inventory/useInventory"
import { SkeletonTitle } from "@/organisms/Drawers/components/SkeletonTitle"
import { useLink } from "@/organisms/Drawers/hooks/useLink"

import type { EntityRecord } from "@/organisms/Drawers/applications/common"

export const TitleApplicationDrawer = (
  props: EntityRecord & { drawerId: string }
) => {
  const context = useApplicationEntity(props.record?.id)
  const [{ response, isLoading }] = context || {}
  const { data } = response || {}
  const link = useLink(props.drawerId)
  const { t } = useTranslation()

  if (isLoading || !data?.length) return <SkeletonTitle />

  const application = data[0]
  const { displayName, environment, namespace, workloadStatus } = application
  // A Lambda function or an Azure app shows its platform icon; any other application (or one
  // from an API that sends no applicationSource) the generic one
  const { Icon = DeploymentUnitOutlined } =
    getApplicationSourceDisplay(application) || {}

  return (
    <TitleDrawer
      icon={<Icon />}
      title={displayName}
      subTitle={
        <Flex gap={8} align="center">
          <span>{`Environment: ${environment} | Namespace: ${namespace}`}</span>
          <ApplicationTag tag type={workloadStatus} t={t} />
        </Flex>
      }
      aside={<CopyLinkButton link={link} />}
    />
  )
}
